function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @file index.ts
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { Emitter } from '@rc-util/emitter';
export var ColorStrawOperate;

(function (ColorStrawOperate) {
  ColorStrawOperate["LOAD"] = "LOAD";
  ColorStrawOperate["ACTIVATE"] = "ACTIVATE";
  ColorStrawOperate["DEACTIVATE"] = "DEACTIVATE";
  ColorStrawOperate["SET_COLOR"] = "SET_COLOR";
  ColorStrawOperate["FAILED"] = "FAILED";
})(ColorStrawOperate || (ColorStrawOperate = {}));

export var ColorStraw = /*#__PURE__*/function (_Emitter) {
  _inherits(ColorStraw, _Emitter);

  var _super = _createSuper(ColorStraw);

  function ColorStraw() {
    var _this;

    _classCallCheck(this, ColorStraw);

    _this = _super.apply(this, arguments);
    _this.connected = false;

    _this.handleMessage = function (e) {
      switch (e.data.type) {
        case 'xj-dropper-active':
          _this.connected = true;

          _this.track(ColorStrawOperate.ACTIVATE);

          break;

        case 'xj-dropper-deactivate':
          _this.connected = false;
          window.clearTimeout(_this.timeout);

          _this.track(ColorStrawOperate.DEACTIVATE);

          break;

        case 'xj-dropper-set-color':
          _this.emit('change', e.data.color);

          window.removeEventListener('message', _this.handleMessage);

          _this.track(ColorStrawOperate.SET_COLOR);

          break;

        default:
          break;
      }
    };

    return _this;
  }

  _createClass(ColorStraw, [{
    key: "isConnected",
    value: function isConnected() {
      return this.connected;
    }
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      window.removeEventListener('message', this.handleMessage);
      window.addEventListener('message', this.handleMessage);
      this.connected = false;
      this.track(ColorStrawOperate.LOAD);
      window.postMessage({
        type: 'xj-crx-dropper-activate',
        options: {
          cursor: 'none',
          enableColorToolbox: false,
          enableColorTooltip: true,
          enableRightClickDeactivate: true
        }
      }, '*');
      this.timeout = window.setTimeout(function () {
        if (!_this2.connected) {
          window.removeEventListener('message', _this2.handleMessage);

          _this2.track(ColorStrawOperate.FAILED);
        }

        _this2.connected = false;
      }, 500);
    }
  }, {
    key: "track",
    value: function track(type) {
      this.emit('track', type);
    }
  }]);

  return ColorStraw;
}(Emitter);